import { render, staticRenderFns } from "./TableForScription.vue?vue&type=template&id=860a9d38&scoped=true"
import script from "./TableForScription.vue?vue&type=script&lang=js"
export * from "./TableForScription.vue?vue&type=script&lang=js"
import style0 from "./TableForScription.vue?vue&type=style&index=0&id=860a9d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860a9d38",
  null
  
)

export default component.exports